<template>
  <div @click="$emit('click')" class="chat-contact d-flex align-center pa-1 cursor-pointer rounded-lg"
    :class="{ 'bg-gradient-primary active-chat-contact': selected }">
    <v-avatar size="28" class="v-avatar-light-bg" :class="[{ 'bg-static-white': false }, `red--text`]">
      <v-img v-if="image" :src="image"></v-img>
      <v-icon :color="selected ? 'white' : 'primary'" v-else>{{ icon }}</v-icon>
    </v-avatar>

    <div class="ml-2 flex-grow-1 overflow-hidden">
      <p class="mb-0 font-weight-medium text--primary">
        {{ name }}
      </p>
      <p class="text--disabled mb-0 text-truncate">
        {{ subtitle }}
      </p>
    </div>
    <div class="chat-meta d-flex flex-column align-self-stretch align-end">
      <v-icon :title="trailingIconTooltip ? trailingIconTooltip : null" :color="selected ? 'white' : 'primary'">{{
        trailingIcon }}</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "id",
    "selected",
    "icon",
    "image",
    "name",
    "subtitle",
    "boldSubtitle",
    "trailingIcon",
    "trailingIconTooltip",
  ],
};
</script>

<style></style>
